import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import utilsMessages from 'utils/messages';
import Money from 'components/Money/Money';
import FreeShippingImage from './FreeShippingImage.png';
import NoteIcon from './NoteIcon';

const NoteIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2px;
  color: #4b5563;
`;
const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Image = styled.img`
  border-radius: 2px;
`;

const Title = styled.div`
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #242527;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const DescriptionItem = styled.div`
  display: flex;
  align-items: center;
`;

const DescriptionLabel = styled.div`
  flex: 1;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  color: #585a60;
`;
const DescriptionValue = styled.div`
  flex: 1;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #242527;
`;

const ButtonFooter = styled(Button)`
  padding: 8px auto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  width: 100%;
  height: 40px;
`;

interface ServiceFeeNoteProps {
  deliveryFee: number;
  areaGroupName?: string;
  deliveryFeeThreshold?: number;
  moq?: number;
}
const ServiceFeeNote = (props: ServiceFeeNoteProps) => {
  const { deliveryFee, areaGroupName, deliveryFeeThreshold, moq } = props;
  const [openServiceFeeNoteModal, setOpenServiceFeeNoteModal] = useState(false);

  return (
    <>
      <NoteIconWrapper
        onClick={() => {
          setOpenServiceFeeNoteModal(true);
        }}
      >
        <NoteIcon />
      </NoteIconWrapper>
      <Modal open={openServiceFeeNoteModal} closable={false} footer={false}>
        <ModalWrapper>
          <Image src={FreeShippingImage} alt={'Free shipping image'} />
          <Title>
            <FormattedMessage {...utilsMessages.conditionForFreeService} />
          </Title>
          <DescriptionContainer>
            <DescriptionItem>
              <DescriptionLabel>
                <FormattedMessage {...utilsMessages.regionalGroup} />:
              </DescriptionLabel>
              <DescriptionValue>{areaGroupName}</DescriptionValue>
            </DescriptionItem>
            <DescriptionItem>
              <DescriptionLabel>
                <FormattedMessage {...utilsMessages.moq} />:
              </DescriptionLabel>
              <DescriptionValue>
                <Money>{moq || 0}</Money>
              </DescriptionValue>
            </DescriptionItem>
            <DescriptionItem>
              <DescriptionLabel>
                <FormattedMessage {...utilsMessages.serviceFee} />:
              </DescriptionLabel>
              <DescriptionValue>
                <Money>{deliveryFee || 0}</Money>
              </DescriptionValue>
            </DescriptionItem>
            <DescriptionItem>
              <DescriptionLabel>
                <FormattedMessage {...utilsMessages.freeServiceCondition} />:
              </DescriptionLabel>
              <DescriptionValue>
                <FormattedMessage {...utilsMessages.ordersOver} /> <Money>{deliveryFeeThreshold || 0}</Money>
              </DescriptionValue>
            </DescriptionItem>
          </DescriptionContainer>
          <ButtonFooter
            type="default"
            onClick={() => {
              setOpenServiceFeeNoteModal(false);
            }}
          >
            <FormattedMessage {...utilsMessages.gotItv2} />
          </ButtonFooter>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default ServiceFeeNote;
